import React from 'react'
import styles from './SectionHeading.module.css'
import Reveal from '../Reveal/Reveal'

type SectionHeadingProps = {
    /** 要素ごとに改行して表示。1行なら要素1つの配列にする */
    title: string[]
    /** タイトル上の小ラベル（例: "pickup"） */
    eyebrow?: string
    /** 余白などページ側の調整用 */
    className?: string
    /** ビュー計測用ラベル（data-view-label） */
    analyticsLabel: string
}

/** 中央寄せの見出し＋アクセント色の下線。Reveal 付き */
export default function SectionHeading({
    title,
    eyebrow,
    className,
    analyticsLabel,
}: SectionHeadingProps) {
    return (
        <Reveal
            className={`${styles.heading} ${className ?? ''}`}
            analyticsLabel={analyticsLabel}
        >
            {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
            <h2 className={styles.title}>
                {title.map((line, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {line}
                    </React.Fragment>
                ))}
            </h2>
            <span className={styles.underline} />
        </Reveal>
    )
}
